export { default } from './SearchResultsHeader';